import {useToast} from "@chakra-ui/react";
import {useRef} from "react";
import {UseToastOptions} from "@chakra-ui/react";
import {ApiResponse} from "../services/api";
import * as Sentry from "@sentry/nextjs";


export const useStatusToast = () => {

  const toast = useToast()

  const toastIdRef = useRef()


  function updateToast(data: Omit<UseToastOptions, "id">) {
    if (toastIdRef.current) {
      toast.update(toastIdRef.current, {status: "success", ...data})
    }
  }

  function addToast(data: Omit<UseToastOptions, "id">) {
    // @ts-ignore
    toastIdRef.current = toast(data)
  }

  const addToastApi = (isUpdate: boolean) => (result: ApiResponse<any>, data: Omit<UseToastOptions, "id">) => {
    if (result.code < 400) {
      if (isUpdate) {
        updateToast(data)
      } else {
        addToast(data)
      }
    } else {
      Sentry.captureEvent({
        message: "Error Toast",
        extra: {
          error: result.error
        }
      })
      const errData: Omit<UseToastOptions, "id"> = {title: "Oops", status: "error", description: result.error}

      if (isUpdate) {
        updateToast(errData)
      } else {
        addToast(errData)
      }
    }
  }
  const toastCatch = (e: any) => {
    addToast({title: "Oops", status: "error", description: e?.message})
  }

  return {
    addToast,
    updateToast,
    addToastResult: addToastApi(false),
    updateToastResult: addToastApi(true),
    toastCatch: toastCatch,
    toast: toast
  }


}
